const config = {
	// 'baseUrl':'http://127.0.0.1:5000',
	//'baseUrl':'https://dsd43sdsf3.execute-api.eu-central-1.amazonaws.com/dev',
	'baseUrl':process.env.REACT_APP_API_BASE_URL,
}

export default config;